import { defaultHeaders } from 'utils/network/ServiceHelper';
import { api } from 'utils/network/api';
import { axios } from 'utils/network/axios';

const url = process.env.REACT_APP_BASE_URL;

class RolesService {
  list(body) {
    return api({
      baseUrl: url,
      endpoint: '/role/list',
      method: 'POST',
      body: JSON.stringify(body),
      headers: defaultHeaders
    });
  }

  post(body) {
    return axios.post('/role/', body);
  }

  put(body) {
    return axios.put(`/role/${body.id}`, body);
  }

  delete(id) {
    return axios.delete(`/role/${id}`);
  }
}

export default new RolesService();
